<script>

    import { setActiveTab } from './TabView/TabView.svelte';
    import { elementTabs } from './Workspaces/tabStore.js';
  
    export let tab = null;
    export let style = null;
  
    function handleClick() {
        if (tab) {
            elementTabs.set(
                setActiveTab(tab, $elementTabs)
            )
        }
    }
  
  </script>
  
  <a
      href={`#${tab}`}
      style={style || ''}
      on:click|stopPropagation={handleClick}
  >
      <slot />
  </a>
  